var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.type === 1
        ? _c(
            "div",
            { staticClass: "feet-r" },
            [
              _c(
                "el-popover",
                {
                  attrs: { placement: "bottom-start", trigger: "hover" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "reference",
                        fn: function () {
                          return [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value: "btn:aRGeneration:addCharge",
                                    expression: "'btn:aRGeneration:addCharge'",
                                    arg: "remove",
                                  },
                                ],
                                attrs: { size: "small" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "receivablePayable.AddModifyExpenses"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3543539458
                  ),
                },
                [
                  _c(
                    "div",
                    { staticClass: "feet" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "feet-btn",
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.operationBtn(1)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("receivablePayable.AddChargesInBulk")
                            ) + " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "feet-btn",
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.operationBtn(2)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("receivablePayable.batchModifyFees")
                            ) + " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "feet-btn",
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.importFees(1)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("receivablePayable.ImportAddCharges")
                            ) + " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "feet-btn",
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.importFees(2)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("receivablePayable.ImportModifyExpenses")
                            ) + " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "feet-btn",
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.quickRecord(1)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("receivablePayable.QuickRecord")) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "feet-btn",
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.quickRecord(2)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("receivablePayable.BatchImportClips")
                            ) + " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "feet-btn",
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.delOrder },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "receivablePayable.BatchDeleteExpensesByOrderNo"
                              )
                            ) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-popover",
                {
                  attrs: { placement: "bottom-start", trigger: "hover" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "reference",
                        fn: function () {
                          return [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value: "btn:aRGeneration:generate",
                                    expression: "'btn:aRGeneration:generate'",
                                    arg: "remove",
                                  },
                                ],
                                attrs: { size: "small", type: "primary" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "receivablePayable.GenerateReceivables"
                                    )
                                  ) + " "
                                ),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1357816869
                  ),
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.operationBtn(3)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("receivablePayable.GenerateReceivables")
                        ) + " "
                      ),
                    ]
                  ),
                  _c("import-receivable-generation", {
                    attrs: { "fee-type-options": _vm.feeList, type: 2 },
                  }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:aRGenerationNew:remarks",
                      expression: "'btn:aRGenerationNew:remarks'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.operationBtn(5)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("receivablePayable.remark")) + " ")]
              ),
              _c("ExportButCmp", {
                attrs: {
                  "query-form": _vm.queryForm,
                  "select-data": _vm.selectData,
                  "current-columns": _vm.currentColumns,
                },
              }),
              _c(
                "el-popover",
                {
                  attrs: { placement: "bottom-start", trigger: "hover" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "reference",
                        fn: function () {
                          return [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value:
                                      "btn:aRGenerationNew:RecalculateThePrice",
                                    expression:
                                      "'btn:aRGenerationNew:RecalculateThePrice'",
                                    arg: "remove",
                                  },
                                ],
                                attrs: { size: "small" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "receivablePayable.RecalculateThePrice"
                                    )
                                  ) + " "
                                ),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2737052284
                  ),
                },
                [
                  _c(
                    "div",
                    { staticClass: "feet" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.operationBtn(7)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("receivablePayable.RecalculateThePrice") +
                                "(" +
                                _vm.$t("receivablePayable.Maximum100000") +
                                ")"
                            ) + " "
                          ),
                        ]
                      ),
                      _vm.type !== 2
                        ? [
                            _c(
                              "el-button",
                              {
                                staticClass: "feet-btn",
                                attrs: { size: "small", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.getImportTemplate(2)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "receivablePayable.ImportCalculatePrices"
                                    )
                                  ) + " "
                                ),
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                staticClass: "feet-btn",
                                attrs: { size: "small", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.getImportTemplate(3)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "receivablePayable.ImportWeightsCalculatePrices"
                                    )
                                  ) + " "
                                ),
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                staticClass: "feet-btn",
                                attrs: { size: "small", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.postcodeCalculation(5)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "receivablePayable.ImportPostcodeCalculation"
                                    )
                                  ) + " "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:aRGenerationNew:deleteRow",
                      expression: "'btn:aRGenerationNew:deleteRow'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small", type: "danger" },
                  on: { click: _vm.deleteRow },
                },
                [_vm._v(_vm._s(_vm.$t("receivablePayable.Delete")) + " ")]
              ),
              _c("CustomStatusBar", {
                staticClass: "feet-btn",
                attrs: {
                  "columns-data": _vm.columns,
                  params: _vm.searchParams,
                  "save-params": _vm.customParams,
                },
                on: { updateColumns: _vm.updateColumns },
              }),
              _vm.type === 1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permit",
                          rawName: "v-permit:remove",
                          value: "btn:aRGeneration:PushFastHandCharge",
                          expression: "'btn:aRGeneration:PushFastHandCharge'",
                          arg: "remove",
                        },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.onPushFastHandCharge },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("orderCenterCont.PushFastHandCharge")) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("CustomStatusBar", {
        staticClass: "feet-btn",
        attrs: {
          "columns-data": _vm.columns,
          params: _vm.searchParams,
          "save-params": _vm.customParams,
        },
        on: { updateColumns: _vm.updateColumns },
      }),
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            title:
              _vm.addType === 1
                ? _vm.$t("receivablePayable.AddChargesInBulk")
                : _vm.$t("receivablePayable.FeeDetails"),
            visible: _vm.showBatchAdd,
            "custom-class": "drawerClass",
            direction: "ltr",
            size: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showBatchAdd = $event
            },
          },
        },
        [
          _c("batch-add-fee", {
            key: _vm.batchAddKey,
            attrs: {
              type: _vm.type,
              "add-type": _vm.addType,
              "fee-type-option": _vm.feeList,
              "query-fee-param": _vm.queryFeeParam,
              "query-form": _vm.queryForm,
              "select-data": _vm.selectData,
            },
            on: { saveForm: _vm.saveForm },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.$t("receivablePayable.SnapshotFee"),
            visible: _vm.showAddSnapshotFee,
            "custom-class": "drawerClass",
            direction: "ltr",
            size: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAddSnapshotFee = $event
            },
          },
        },
        [
          _c("add-snapshot-fee", {
            key: _vm.snapshotFeeKey,
            attrs: {
              "expense-sub-list": _vm.expenseSubList,
              "fee-type-option": _vm.feeList,
              "query-fee-param": _vm.queryFeeParam,
            },
            on: { saveFormSnapshot: _vm.saveFormSnapshot },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.expensesType === 1
                ? _vm.$t("receivablePayable.ImportAddCharges")
                : _vm.$t("receivablePayable.ImportModifyExpenses"),
            visible: _vm.showModification,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showModification = $event
            },
          },
        },
        [
          _vm.expensesType === 1
            ? _c(
                "div",
                [
                  _c("import-add-fee", {
                    on: { changeFeeList: _vm.changeFeeList },
                  }),
                ],
                1
              )
            : _vm.expensesType === 2
            ? _c(
                "div",
                [
                  _c("batch-change", {
                    on: { changeFeeList: _vm.changeFeeList },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("receivablePayable.BatchImportClips"),
            visible: _vm.showBatchImportClips,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showBatchImportClips = $event
            },
          },
        },
        [
          _c("batch-import-clips", {
            key: _vm.snapshotImportClips,
            attrs: { "outlets-list": [] },
            on: { importClips: _vm.importClips },
          }),
        ],
        1
      ),
      _c("ModifyFee", {
        ref: "modifyFeeRef",
        attrs: {
          "fee-type-option": _vm.feeList,
          "query-form": _vm.queryForm,
          "select-data": _vm.selectData,
        },
        on: { close: _vm.searchFun },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("receivablePayable.BatchDeleteExpensesByOrderNo"),
            visible: _vm.showBatchDeleteExpensesByOrderNo,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showBatchDeleteExpensesByOrderNo = $event
            },
          },
        },
        [
          _c("BatchDelOrder", {
            key: _vm.batchDeleteExpensesByOrderNo,
            attrs: { "fee-type-option": _vm.feeList },
            on: { importDelOrder: _vm.importDelOrder },
          }),
        ],
        1
      ),
      _c("ReceivableDialog", {
        ref: "receivableRefDialog",
        attrs: { "select-data": _vm.selectData, "query-form": _vm.queryForm },
        on: { change: _vm.searchTable },
      }),
      _c("RemarkDialog", {
        ref: "remarkRefDialog",
        attrs: { "select-data": _vm.selectData, "query-form": _vm.queryForm },
        on: { change: _vm.searchTable },
      }),
      _c("DelFeeDialog", {
        ref: "delRefDialog",
        attrs: {
          "select-data": _vm.selectData,
          "query-form": _vm.queryForm,
          "fee-list": _vm.feeList,
        },
        on: { change: _vm.searchTable },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("receivablePayable.RecalculateThePrice"),
            visible: _vm.recalculate,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.recalculate = $event
            },
            close: function ($event) {
              return _vm.changePage(false)
            },
          },
        },
        [
          _c("recalculatePrice", {
            key: _vm.showManage1,
            attrs: {
              "calculation-type": 0,
              "get-param": _vm.queryForm,
              "import-data": _vm.importData,
              "select-data": _vm.selectData,
            },
            on: { changePage: _vm.changePage },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }